module.exports = __webpack_public_path__ + "static/media/Icon-arrow-red.495185ee.png";